import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useWatchAccount } from './account';
import { useWatchChain } from './chain';
export function useAtomWatchers() {
    useWatchAccount();
    useWatchChain();
}
export const AtomWatchers = ({ children }) => {
    useWatchAccount();
    useWatchChain();
    return _jsx(Fragment, { children: children });
};
